/** React libraries */
import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import {
  reactPlugin
} from "../utils/appInsights";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { logout } from './../services/auth.api';

/**  Pages */
import Dashboard from "../pages/Dashboard/Dashboard";
import ErrorPage from "../pages/ErrorPage/ErrorPage";
import AuthCallback from "../pages/AuthCallBack/AuthCallback";
import LogoRequest from "../pages/LogoRequest/LogoRequest";
import ManageLogoPortalUser from "../pages/Manage-Logo-Portal-User/ManageLogoPortalUser";
import Certificate from "../pages/Certificates/Certificate";
import ManageBanners from "../pages/Banner Management/BannerManagement";
import Login from "../pages/Login/Login";
import FAQ from "../pages/FAQ/FAQ";
import Home from "../pages/Home/Home"

/** Custom components */
import Sidebar from "../components/Sidenav/sidenav.components";
import { AUTH_STATUS } from "../utils/authUtils";
import useAuth from "../context/AuthContext";

const DashboardWithTracking = withAITracking(reactPlugin, Dashboard);

const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("access_token");
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      logout();
    }
  }, [isAuthenticated, navigate]);

  if (isAuthenticated) {
    return children;
  }
  return null;
};

export const AppRouter: React.FC = () => {
  const { AUTHENTICATED } = AUTH_STATUS;
  const { status } = useAuth();
  return (
    <div className="app-container">
      {status === AUTHENTICATED &&
        <Sidebar />
      }
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/callback" element={<AuthCallback />} />
          <Route
            path="/dashboard/:certificateId"
            element={
              <ProtectedRoute>
                <DashboardWithTracking />
              </ProtectedRoute>
            }
          />
          <Route
            path="/certificates"
            element={
              <ProtectedRoute>
                <Certificate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manageUser"
            element={
              <ProtectedRoute>
                <ManageLogoPortalUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="/setting"
            element={
              <ProtectedRoute>
                <ErrorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logoRequest/:certificateId/:type"
            element={
              <ProtectedRoute>
                <LogoRequest />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logoRequest/:certificateId/:requestId/:type"
            element={
              <ProtectedRoute>
                <LogoRequest />
              </ProtectedRoute>
            }
          />
          <Route path="/manageBanners" element={
            <ProtectedRoute>
              <ManageBanners />
            </ProtectedRoute>
          } />
          <Route path="/home" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>}
          />
          <Route path="/faqs" element={
            <ProtectedRoute>
              <FAQ />
            </ProtectedRoute>}
          />
          <Route path="/logout" element={<Login />} />
          <Route path="/ErrorPage" element={<ErrorPage />} />
          <Route path="*" element={<Navigate to="/ErrorPage" replace />} />
        </Routes>
      </div>
    </div>
  );
};
